import React, {Component} from "react";
import {connect} from "react-redux";
import moment from "moment";
import {Constants, Globals, axios} from "../../../utils";
import {Button, Select} from "../../../components";
import CloseIcon from "../../../assets/icons/close-black.png";
import RecicleIcon from "../../../assets/icons/recycle.png";

function parse(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}

const DELETE_TYPE = {
  TOTAL: 1,
  PARTIAL: 2,
};

class ModalCreateReturn extends Component {
  state = {
    isReadOnly: false,
    showLoteAgotadoModal: false,
    returnedItem: this.props.returnedItem,
    exchangeRate: 0,
    deleteType: DELETE_TYPE.TOTAL,
    form: {
      payment_method_id: "",
      bill_number: "",
      comments: "",
      affects_inventory: false,
    },
    totals: {
      subtotal_usd: 0,
      subtotal_bs: 0,
      paid_usd: 0,
      paid_bs: 0,
      left_usd: 0,
      left_bs: 0,
      total_bs: 0,
      total_usd: 0,
      change_bs: 0,
      change_usd: 0,
      iva_8_bs: 0,
      iva_8_usd: 0,
      iva_16_bs: 0,
      iva_16_usd: 0,
      iva_31_bs: 0,
      iva_31_usd: 0,
      iva_bs: 0,
      iva_usd: 0,
      igtf_bs: 0,
      igtf_usd: 0,
      discount_bs: 0,
      discount_usd: 0,
    },
    warehouses: [],
    methods: [],
  };

  componentDidMount() {
    console.log("returnedItem backend data:", this.props.returnedItem);
    if (!!this.props?.isReadOnly) this.edit();

    //Seteo el nro de factura SOLO SÍ es formato libre
    if (this.state.returnedItem && !this.props?.isReadOnly) {
      if (this.state.returnedItem.fiscal_bill_free == 1) {
        this.setState((s) => ({
          form: {
            ...s.form,
            bill_number: this.props.returnedItem?.bill_number_format,
          },
        }));
      }
    }

    this.formatOrder();
    this.getExchangeRate();
    this.getWarehouses();
    this.getPaymentMethods();
  }

  toggleLoteAgotadoModal = () => {
    this.setState((s) => ({showLoteAgotadoModal: !s.showLoteAgotadoModal}));
  };

  formatOrder = async () => {
    const formatProduct = (item) => {
      if (!item) return;
      console.log("DEBUG formatProduct -> original:", item.quantity);
      const warehouse_id = Number(
        item.warehouse_id || this.props.user.warehouse_principal,
      );
      let total_quantity = undefined;

      // Busca el producto en los almacenes
      const wh = this.state.warehouses.find((i) => i.id === warehouse_id);
      if (wh) {
        const wp = wh.products.find((i) => i.product_id === item.product_id);
        total_quantity = wp?.total_quantity;
        if (wp?.product) item.product = Globals.copy(wp.product);
      }

      let stock = item.product.stock;
      if (item.product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = item.product.size_colors.find(
          (sc) => sc.size_id === item.size_id && sc.color_id === item.color_id,
        );

        stock = size_color?.stock || 0;
        if (!!size_color?.color)
          item.product.name += `, ${size_color.color.name}`;
        if (!!size_color?.size)
          item.product.name += `, ${size_color.size.name}`;
      }

      return {
        ...item,
        isFormatted: true,
        isDeleted: item.isDeleted ?? true,
        originalQuantity: Number(
          item.isFormatted ? item.originalQuantity : item.quantity,
        ),
        quantity: String(item.isFormatted ? item.quantity : 0),
        stock,
        total_quantity,
        warehouse_id,
      };
    };

    const isFormatted = this.state.returnedItem.details[0]?.isFormatted;
    const isReadOnly = this.props.isReadOnly;
    let prods = [];

    if (isReadOnly) {
      // Está visualizando la Nota de Crédito
      // Si ya está formateado, tomar los productos de la base, si no, tomar los productos de la nota de crédito
      prods = isFormatted
        ? this.state.returnedItem.details
        : this.state.returnedItem.details;
    } else {
      prods = this.state.returnedItem.details;
    }

    prods = prods?.map(formatProduct);

    await this.setState((s) => ({
      returnedItem: {
        ...s.returnedItem,
        details: prods,
      },
    }));

    if (
      isReadOnly &&
      !isFormatted &&
      this.state.deleteType === DELETE_TYPE.TOTAL
    )
      this.changeType(DELETE_TYPE.PARTIAL);
  };

  edit = async () => {
    let bill_number = null;
    if (
      this.props.returnedItem?.fiscal_bill == Constants.ORDERS.FISCAL_BILL.YES
    ) {
      bill_number = this.props.returnedItem?.order_bill?.bill_number;
    } else if (
      this.props.returnedItem?.fiscal_bill_free ==
      Constants.ORDERS.FISCAL_BILL_FREE.YES
    ) {
      bill_number = this.props.returnedItem?.bill_number_format;
    }

    await this.setState({
      isReadOnly: true,
      form: {
        payment_method_id:
          this.props.returnedItem?.return?.payments[0]?.method_id,
        bill_number: bill_number,
        comments: this.props.returnedItem?.comments,
      },
    });
  };

  getWarehouses = async () => {
    try {
      const data = {
        web: true,
        user_id: this.props.user.id,
        is_select: true,
        warehouse_id:
          this.props.user.level_id == Constants.ROLE_ADMIN
            ? null
            : this.props.user.warehouse_id,
        unique_by_size_color: true, //para que traiga solo una talla/color en caso de ser por talla/color
      };

      const res = await axios.post("web/admin/warehouses", data);
      if (res.data?.warehouses) {
        await this.setState({warehouses: res.data.warehouses});
        this.formatOrder();
      }
    } catch (error) {
      Globals.showError();
      console.log("NewRequest -> getWarehouses -> catch: ", error);
    }
  };

  getExchangeRate = async () => {
    try {
      if (this.props.isReadOnly) {
        await this.setState({
          exchangeRate: parseFloat(this.state.returnedItem.conversion) || 0,
        });
        this.setTotals();
      } else {
        const filter = {user_id: this.props.user.id};

        const res = await axios.post("admin/conversions/getbcv", filter);
        if (!res.data?.conversion)
          throw Error("Debe establecer una tasa de cambio para continuar");

        await this.setState({exchangeRate: res.data?.conversion || 0});
        this.setTotals();
      }
    } catch (error) {
      Globals.showError(error?.message);
      console.log("NewRequest -> getExchangeRate -> catch:", error);
    }
  };

  getPaymentMethods = async () => {
    try {
      const filter = {
        user_id: this.props.user.id,
      };

      const res = await axios.post("web/admin/orders/methods", filter);
      if (!res.data?.methods)
        throw Error("No se encontraron los métodos de pago");

      this.setState({methods: res.data?.methods});
    } catch (error) {
      Globals.showError(error?.message);
      console.log("Return -> getPaymentMethods -> catch:", error);
    }
  };

  toggleProduct = async (index) => {
    let details = Globals.copy(this.state.returnedItem.details);
    details[index].isDeleted = !details[index].isDeleted;
    details[index].quantity = String(
      details[index].isDeleted ? 0 : details[index].originalQuantity,
    );
    await this.setState((s) => ({returnedItem: {...s.returnedItem, details}}));
    await this.setTotals();
  };

  changeType = async (deleteType) => {
    const products = Globals.copy(this.state.returnedItem.details);
    console.log("DEBUG changeType -> Tipo seleccionado:", deleteType);
    if (deleteType === DELETE_TYPE.TOTAL) {
      products.forEach((i) => {
        i.quantity = String(0);
      });
    } else {
      products.forEach((i) => {
        i.quantity = String(i.originalQuantity);
      });
    }
    console.log("DEBUG changeType -> Productos actualizados:", products);
    await this.setState((s) => ({
      deleteType,
      returnedItem: {...s.returnedItem, details: products},
    }));
    await this.setTotals();
  };

  oneMoreProduct = async (index) => {
    const products = Globals.copy(this.state.returnedItem.details);
    const product = products[index];
    let qty = Number(products[index].quantity);
    let newQuantity = qty + 1;
    if (product.product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      newQuantity = parseFloat(qty + 1).toFixed(2);
    }

    if (newQuantity > product.originalQuantity) return;

    const stockToValidate =
      products[index].product.total_quantity !== undefined
        ? products[index].product.total_quantity
        : products[index].product.stock;

    if (Number(newQuantity) > Number(stockToValidate))
      return Globals.showError(
        `No hay suficiente stock de ${products[index].product.name}`,
      );

    products[index].quantity = newQuantity;
    await this.setState((s) => ({
      returnedItem: {...s.returnedItem, details: products},
    }));
    this.setTotals();
  };

  oneLessProduct = async (index) => {
    const products = Globals.copy(this.state.returnedItem.details);
    const product = products[index];
    let qty = Number(products[index].quantity);
    let newQuantity = qty - 1;
    if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      newQuantity = parseFloat(qty - 1).toFixed(2);
    }

    if (newQuantity < 0) return;

    const stockToValidate =
      products[index].product.total_quantity !== undefined
        ? products[index].product.total_quantity
        : products[index].product.stock;

    if (Number(newQuantity) > Number(stockToValidate)) {
      newQuantity = stockToValidate;
      Globals.showError(
        `No hay suficiente stock de ${products[index].product.name}`,
      );
    }

    products[index].quantity = newQuantity;
    await this.setState((s) => ({
      returnedItem: {...s.returnedItem, details: products},
    }));
    this.setTotals();
  };

  changeManual = async (index, quantity) => {
    const products = Globals.copy(this.state.returnedItem.details);
    let newQuantity = quantity;

    if (products[index].product?.decimal_stock === Constants.DECIMAL_STOCK.NO) {
      newQuantity = newQuantity === "" ? newQuantity : parseInt(newQuantity);
    } else {
      newQuantity = newQuantity.replace(/,/g, ".");
    }

    products[index].quantity = newQuantity;
    products[index].showPrices = false;
    await this.setState((s) => ({
      returnedItem: {...s.returnedItem, details: products},
    }));
    this.setTotals();
  };

  setTotalsOLD = (onlyDisabled = false) => {
    const {returnedItem} = this.state;
    console.log("returnedItem: ", returnedItem);
    const exchangeRate = this.state.exchangeRate || 1;

    let subtotal_without_disc_usd = 0;
    let subtotal_without_disc_bs = 0;
    let subtotal_usd = 0;
    let subtotal_bs = 0;
    let left_usd = 0;
    let left_bs = 0;
    let total_bs = 0;
    let total_usd = 0;
    let change_bs = 0;
    let change_usd = 0;
    let iva_bs = 0;
    let iva_usd = 0;
    let iva_8_bs = 0;
    let iva_8_usd = 0;
    let iva_16_bs = 0;
    let iva_16_usd = 0;
    let iva_31_bs = 0;
    let iva_31_usd = 0;
    let igtf_bs = 0;
    let igtf_usd = 0;
    let total_taxes_usd = 0;
    let total_taxes_bs = 0;

    const products = onlyDisabled
      ? [...returnedItem.details].filter(
          (i) =>
            i.isDeleted ||
            parseFloat(i.quantity) !== parseFloat(i.originalQuantity),
        )
      : [...returnedItem.details];

    const paymentMethods =
      returnedItem.order?.payment_methods ?? returnedItem.payment_methods ?? [];

    const paid_usd = parse(
      paymentMethods.reduce((acc, curr) => acc + Number(curr.amount || 0), 0),
    );
    const paid_bs = parse(
      paymentMethods.reduce(
        (acc, curr) => acc + Number(curr.amount_bs || 0),
        0,
      ),
    );

    // Paso 1: Calcular subtotales por producto
    for (const product of products) {
      const qty = onlyDisabled
        ? parseFloat(product.originalQuantity - product.quantity)
        : product?.decimal_stock == Constants.DECIMAL_STOCK.YES
          ? parseFloat(product.quantity)
          : parseInt(product.quantity);

      const price = product?.price ?? product.sale_price;
      const subtotalWithoutDiscount = parse(qty * price);
      const discountPercentage =
        product.discount_percentage ?? product.discount;
      const discountAmount =
        discountPercentage > 0
          ? parse((subtotalWithoutDiscount * discountPercentage) / 100)
          : 0;

      // Calcular subtotal con descuento del producto
      const productSubtotal =
        discountPercentage > 0
          ? subtotalWithoutDiscount - discountAmount
          : subtotalWithoutDiscount;

      // Guardar en el producto
      product.subtotalWithoutTaxes = productSubtotal;
      product.subtotal = productSubtotal;
      subtotal_usd += productSubtotal;

      // Calcular IVA si el producto no es exento
      if (product?.product?.exento == Constants.PRODUCT_EXENTO.NO) {
        const ivaPercentage = product?.product?.iva_porcentage ?? 0;
        const iva_product = parse((productSubtotal * ivaPercentage) / 100);

        // Acumular IVA
        iva_usd += iva_product;
        product.iva_usd = iva_product;

        // Acumular por categoría de IVA
        const iva = product?.product?.iva ?? product.iva;
        if (iva === Constants.PRODUCT_IVA.DIECISEIZ) {
          iva_16_usd += iva_product;
        } else if (iva === Constants.PRODUCT_IVA.OCHO) {
          iva_8_usd += iva_product;
        } else if (iva === Constants.PRODUCT_IVA.TREINTAIUNO) {
          iva_31_usd += iva_product;
        }

        // ¡IMPORTANTE! Sumar el IVA al subtotal del producto
        // Esto es lo que se hace en la creación de pedidos
        product.subtotal = parse(productSubtotal + iva_product);
      }

      product.isDeleted = parseFloat(product.quantity) === 0;
      product.isReturning =
        parseFloat(product.quantity) !== parseFloat(product.originalQuantity);
      product.discount = discountAmount;
      product.total = product.subtotal; // total ahora incluye IVA si aplica
    }

    // Paso 2: Aplicar descuento global
    const discountAmountGlobal =
      returnedItem.discount_percentage > 0
        ? parse((subtotal_usd * returnedItem.discount_percentage) / 100)
        : 0;

    subtotal_without_disc_usd = subtotal_usd;
    subtotal_usd =
      returnedItem.discount_percentage > 0
        ? subtotal_usd - discountAmountGlobal
        : subtotal_usd;

    // Aplicar descuento proporcional al IVA
    const ivaDiscountAmount =
      returnedItem.discount_percentage > 0
        ? parse((iva_usd * returnedItem.discount_percentage) / 100)
        : 0;

    iva_usd =
      returnedItem.discount_percentage > 0
        ? iva_usd - ivaDiscountAmount
        : iva_usd;

    // Paso 3: Conversión a BS
    subtotal_without_disc_bs = parse(subtotal_without_disc_usd * exchangeRate);
    subtotal_bs = parse(subtotal_usd * exchangeRate);
    iva_bs = parse(iva_usd * exchangeRate);
    iva_8_bs = parse(iva_8_usd * exchangeRate);
    iva_16_bs = parse(iva_16_usd * exchangeRate);
    iva_31_bs = parse(iva_31_usd * exchangeRate);

    total_taxes_usd = parse(iva_usd);
    total_taxes_bs = iva_bs;

    // Paso 4: Calcular total
    total_usd = parse(subtotal_usd + total_taxes_usd);

    // Paso 5: Calcular IGTF
    const hasIGTF = paymentMethods.some(
      (method) => !Constants.LOCAL_CURRENCIES.includes(method.method_id),
    );
    console.log("hasIGTF: ", hasIGTF);

    if (hasIGTF) {
      igtf_usd = parse((total_usd * Constants.TAXES.IGTF) / 100);
      igtf_bs = parse(igtf_usd * exchangeRate);
      total_usd = parse(total_usd + igtf_usd);
    }

    total_bs = parse(total_usd * exchangeRate);

    // Paso 6: Calcular saldos y cambios
    left_usd = parse(total_usd - paid_usd);
    left_bs = parse(total_bs - paid_bs);

    if (left_usd < 0) {
      change_usd = parse(Math.abs(left_usd));
      change_bs = parse(change_usd * exchangeRate);
      left_usd = 0;
      left_bs = 0;
    }

    const totals = {
      subtotal_without_disc_usd,
      subtotal_without_disc_bs,
      subtotal_usd,
      subtotal_bs,
      paid_usd,
      paid_bs,
      left_usd,
      left_bs,
      total_bs,
      total_usd,
      change_bs,
      change_usd,
      iva_bs,
      iva_usd,
      iva_8_bs,
      iva_8_usd,
      iva_16_bs,
      iva_16_usd,
      iva_31_bs,
      iva_31_usd,
      igtf_bs,
      igtf_usd,
      discount_bs: parse(discountAmountGlobal * exchangeRate),
      discount_usd: parse(discountAmountGlobal),
    };

    if (onlyDisabled) return totals;

    this.setState((s) => ({
      returnedItem: {
        ...s.returnedItem,
        details: products,
        subtotal: subtotal_usd,
        discount: discountAmountGlobal,
        iva: iva_usd,
        igtf: igtf_usd,
        total: total_usd,
      },
      totals,
    }));
  };

  setTotals = (onlyDisabled = false) => {
    const {returnedItem} = this.state;
    const exchangeRate = this.state.exchangeRate || 1;

    let baseWithoutGeneral_usd = 0;
    let netBase_usd = 0;
    let iva_usd = 0;
    let iva_8_usd = 0;
    let iva_16_usd = 0;
    let iva_31_usd = 0;
    let discount_usd = 0;
    let subtotal_usd = 0;
    let igtf_usd = 0;
    let total_usd = 0;
    let paid_usd = 0;
    let left_usd = 0;
    let change_usd = 0;

    let baseWithoutGeneral_bs = 0;
    let netBase_bs = 0;
    let iva_bs = 0;
    let iva_8_bs = 0;
    let iva_16_bs = 0;
    let iva_31_bs = 0;
    let discount_bs = 0;
    let subtotal_bs = 0;
    let igtf_bs = 0;
    let total_bs = 0;
    let paid_bs = 0;
    let left_bs = 0;
    let change_bs = 0;

    const products = onlyDisabled
      ? [...returnedItem.details].filter(
          (i) =>
            i.isDeleted ||
            parseFloat(i.quantity) !== parseFloat(i.originalQuantity),
        )
      : [...returnedItem.details];

    // 1. Descuentos individuales por producto y marca isReturning
    products.forEach((prod) => {
      // Siempre calcular en base a la cantidad que se DEVUELVE (Original - Mantenida)
      const qty =
        prod?.decimal_stock == Constants.DECIMAL_STOCK.YES
          ? parseFloat(prod.originalQuantity - prod.quantity)
          : parseInt(prod.originalQuantity - prod.quantity, 10);
      console.log(`DEBUG setTotals -> Producto: ${prod.product?.name}`, {
        originalQuantity: prod.originalQuantity,
        mantenerEnFactura: prod.quantity,
        cantidadADevolver: qty,
      });
      const price = prod?.price ?? prod.sale_price;
      const lineGross = qty * price;
      const indivDiscount =
        prod.discount_percentage > 0
          ? (lineGross * prod.discount_percentage) / 100
          : 0;

      prod.baseAfterIndiv_usd = parse(lineGross - indivDiscount);
      prod.subtotalWithoutTaxes = prod.baseAfterIndiv_usd;
      baseWithoutGeneral_usd += prod.baseAfterIndiv_usd;
      prod.qtyToReturn = qty;

      // AJUSTE PARA SUBMIT
      prod.isReturning =
        parseFloat(prod.quantity) !== parseFloat(prod.originalQuantity);
    });

    // 2. Descuento general sobre la suma de bases
    const generalDiscountRate = (returnedItem.discount_percentage || 0) / 100;
    discount_usd = baseWithoutGeneral_usd * generalDiscountRate;
    netBase_usd = parse(baseWithoutGeneral_usd - discount_usd);

    // 3. IVA por producto (proporcional al neto de cada línea)
    products.forEach((prod) => {
      const proportion =
        baseWithoutGeneral_usd > 0
          ? prod.baseAfterIndiv_usd / baseWithoutGeneral_usd
          : 0;
      const lineNetBase = parse(netBase_usd * proportion);

      if (prod?.product?.exento == Constants.PRODUCT_EXENTO.NO) {
        const ivaPct = prod?.product?.iva_porcentage ?? 0;
        const iva = parse((lineNetBase * ivaPct) / 100);
        prod.iva_usd = iva;
        iva_usd += iva;

        // Acumula por tipo de IVA
        const ivaType = prod?.product?.iva ?? prod.iva;
        if (ivaType === Constants.PRODUCT_IVA.OCHO) iva_8_usd += iva;
        else if (ivaType === Constants.PRODUCT_IVA.DIECISEIZ) iva_16_usd += iva;
        else if (ivaType === Constants.PRODUCT_IVA.TREINTAIUNO)
          iva_31_usd += iva;

        prod.subtotal = parse(lineNetBase + iva);
      } else {
        prod.iva_usd = 0;
        prod.subtotal = lineNetBase;
      }
    });

    // 4. IGTF (si método de pago es divisa, solo para el pago de la devolución)
    const paymentMethodId = this.state.form.payment_method_id;
    const isDivisa =
      paymentMethodId &&
      !Constants.LOCAL_CURRENCIES.includes(Number(paymentMethodId));
    if (isDivisa && netBase_usd > 0) {
      igtf_usd = parse((netBase_usd * Constants.TAXES.IGTF) / 100);
    }

    // --- AGREGAR ESTO: Forzar montos exactos si es devolución total ---
    const isTotalReturn = returnedItem.details.every(
      (prod) => parseFloat(prod.quantity) === 0,
    );

    if (isTotalReturn) {
      iva_usd = parseFloat(returnedItem.iva || 0);
      iva_bs = parseFloat(returnedItem.iva_bs || 0);
      igtf_usd = parseFloat(returnedItem.igtf || 0);
      igtf_bs = parseFloat(returnedItem.igtf_bs || 0);
    }
    // -----------------------------------------------------------------

    // 5. Totales finales
    total_usd = parse(netBase_usd + iva_usd + igtf_usd);
    subtotal_usd = baseWithoutGeneral_usd;
    // 6. Conversiones a bolívares
    subtotal_bs = parse(subtotal_usd * exchangeRate);
    discount_bs = parse(discount_usd * exchangeRate);
    netBase_bs = parse(netBase_usd * exchangeRate);
    iva_bs = parse(iva_usd * exchangeRate);
    iva_8_bs = parse(iva_8_usd * exchangeRate);
    iva_16_bs = parse(iva_16_usd * exchangeRate);
    iva_31_bs = parse(iva_31_usd * exchangeRate);
    igtf_bs = parse(igtf_usd * exchangeRate);
    total_bs = parse(total_usd * exchangeRate);

    // 7. Pagos, cambio, saldos
    paid_usd = parse(returnedItem.payment_methods?.[0]?.amount || 0);
    paid_bs = parse(returnedItem.payment_methods?.[0]?.amount_bs || 0);

    left_usd = parse(total_usd - paid_usd);
    left_bs = parse(total_bs - paid_bs);

    if (left_usd < 0) {
      change_usd = parse(-left_usd);
      change_bs = parse(change_usd * exchangeRate);
      left_usd = 0;
      left_bs = 0;
    }

    // Guarda los totales
    const totals = {
      subtotal_without_disc_usd: parse(baseWithoutGeneral_usd),
      subtotal_without_disc_bs: parse(baseWithoutGeneral_usd * exchangeRate),
      subtotal_usd,
      subtotal_bs,
      discount_usd: parse(discount_usd),
      discount_bs: parse(discount_bs),
      netBase_usd,
      netBase_bs,
      iva_usd,
      iva_bs,
      iva_8_usd,
      iva_8_bs,
      iva_16_usd,
      iva_16_bs,
      iva_31_usd,
      iva_31_bs,
      igtf_usd,
      igtf_bs,
      total_usd,
      total_bs,
      paid_usd,
      paid_bs,
      left_usd,
      left_bs,
      change_usd,
      change_bs,
    };

    if (onlyDisabled) return totals;

    this.setState((s) => ({
      returnedItem: {
        ...s.returnedItem,
        details: products,
        subtotal: subtotal_usd,
        discount: discount_usd,
        iva: iva_usd,
        igtf: igtf_usd,
        total: total_usd,
      },
      totals,
    }));
  };

  isValidForm = () => {
    const onError = (msg) => {
      Globals.showError(msg);
      return false;
    };

    const {returnedItem, form} = this.state;

    if (!form.comments)
      return onError("Debe indicar el motivo de la nota de crédito");
    if (!form.bill_number)
      return onError("Debe indicar el número de la factura");

    let item = returnedItem.details.find(
      (i) => isNaN(Number(i.quantity)) || i.quantity === "",
    );
    if (item)
      return onError(
        `Debe ingresar la cantidad del producto (${item.product.name})`,
      );

    item = returnedItem.details.find(
      (i) => Number(i.quantity) > i.originalQuantity,
    );
    if (item)
      return onError(
        `La cantidad no puede ser mayor a la cantidad original (${item.product.name})`,
      );

    item = returnedItem.details.find((i) => Number(i.quantity) < 0);
    if (item)
      return onError(
        `La cantidad debe ser mayor o igual a 0 (${item.product.name})`,
      );

    return true;
  };

  submit = async () => {
    if (!this.isValidForm()) return;
    Globals.setLoading();

    const totals = this.setTotals(true);

    const data = {
      ...this.state.form,
      affects_inventory: this.state.form.affects_inventory ? 1 : 0,
      user_id: this.props.user.id,
      order_id: this.state.returnedItem?.id,
      products: this.state.returnedItem.details
        .filter((i) => i.isReturning)
        .map((x) => ({
          id: x.product.id,
          name: x.product.name,
          code: x.product.code,
          exento: x.product.exento,
          price: x.price,
          quantity: Number(x.originalQuantity) - Number(x.quantity),
          color_id: x.color_id,
          size_id: x.size_id,
          discount_percentage: x.discount_percentage,
          warehouse_id: x.warehouse_id,
        })),
      payment_methods: [
        {
          amount: totals.total_usd,
          amount_bs: totals.total_bs,
          method_id: this.state.form.payment_method_id,
        },
      ],
      discount_percentage: this.state.returnedItem.discount_percentage,
      iva_usd: totals.iva_usd,
      iva_bs: totals.iva_bs,
      igtf_usd: totals.igtf_usd,
      igtf_bs: totals.igtf_bs,
    };
    console.log("data: ", data);

    try {
      const res = await axios.post("admin/orders/fiscal-bill/creditnote", data);

      if (res.data?.lote_agotado || res.data?.result === false) {
        if (
          res.data?.lote_agotado ||
          res.data?.error?.includes("Lote de Formas Libres agotado")
        ) {
          this.setState({showLoteAgotadoModal: true});
        } else if (res.data?.error) {
          Globals.showError(res.data.error);
        }
      }
      //Caso impresora fiscal
      else if (res.data.result) {
        Globals.showSuccess("Nota de crédito creada con éxito");
        this.props.onSuccess();
      }
      //Caso formato libre
      else if (res.data?.url) {
        Globals.showSuccess("Nota de crédito creada con éxito");
        const link = document.createElement("a");
        link.href = res.data?.url;
        link.target = "_blank";
        link.click();
        this.props.onSuccess();
      }
    } catch (error) {
      const errorData = error?.response?.data;
      if (
        errorData?.lote_agotado ||
        errorData?.error?.includes("Lote de Formas Libres agotado")
      ) {
        this.setState({showLoteAgotadoModal: true});
      } else {
        Globals.showError(errorData?.error ?? "Ocurrió un error inesperado");
      }
    }

    Globals.quitLoading();
  };

  change = async (value, target) => {
    await this.setState((s) => ({form: {...s.form, [target]: value}}));
    if (target === "payment_method_id") this.setTotals();
  };

  convert = (value) => {
    return value * (this.state.exchangeRate || 0);
  };

  render() {
    const {
      deleteType,
      form,
      isReadOnly,
      returnedItem,
      totals,
      showLoteAgotadoModal,
    } = this.state;

    return (
      <>
        {showLoteAgotadoModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 99999,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                width: "460px",
                maxWidth: "90%",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fce8e6",
                  padding: "24px 20px 16px 20px",
                  borderBottom: "1px solid #f5c6cb",
                }}
              >
                <div
                  style={{
                    fontSize: "44px",
                    color: "#d93025",
                    lineHeight: "1",
                    marginBottom: "8px",
                  }}
                >
                  ⚠️
                </div>
                <h2
                  style={{
                    color: "#d93025",
                    margin: 0,
                    fontSize: "26px",
                    fontWeight: "bold",
                  }}
                >
                  ¡Advertencia!
                </h2>
              </div>
              <div style={{padding: "24px 30px"}}>
                <p
                  style={{
                    color: "#3c4043",
                    fontSize: "15px",
                    lineHeight: "1.5",
                    margin: 0,
                  }}
                >
                  Lote de Formas Libres agotado. Por favor, configure un nuevo
                  lote autorizado por la imprenta para continuar
                </p>
              </div>
              <div
                style={{
                  padding: "0 20px 20px 20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={this.toggleLoteAgotadoModal}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: "16px",
                    cursor: "pointer",
                    padding: "8px 24px",
                  }}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="modal-top">
          <div>
            <p>Cliente: {returnedItem?.client?.name}</p>
            <p>Cédula: {returnedItem?.client?.document}</p>
            <p className="conversion">
              Tasa de cambio: Bs.{" "}
              {Globals.newFormatMiles(this.state.exchangeRate || 0, 4)}
            </p>
          </div>
          <div>
            {isReadOnly ? (
              // Mostrar cuando isReadOnly es true
              <>
                <p className="date">
                  Fecha de emisión factura:{" "}
                  {moment(returnedItem?.created_at).format("DD/MM/YYYY HH:mm")}
                </p>
                <p>
                  Forma de pago factura: {returnedItem?.payment_methods_text}
                </p>
                <p className="date">
                  Fecha de emisión nota de crédito:{" "}
                  {moment(returnedItem?.return?.created_at).format(
                    "DD/MM/YYYY HH:mm",
                  )}
                </p>
                <p>
                  N° Nota de Crédito:{" "}
                  {this.state.returnedItem?.return?.number_format}
                </p>
              </>
            ) : (
              // Mostrar cuando isReadOnly es false
              <>
                <p className="date">
                  Fecha de emisión:{" "}
                  {moment(returnedItem?.created_at).format("DD/MM/YYYY HH:mm")}
                </p>
                <p>Forma de pago: {returnedItem?.payment_methods_text}</p>
              </>
            )}
          </div>
        </div>

        <div
          className="table-wrapper mb-4"
          style={{display: "flex", justifyContent: "center", gap: "2rem"}}
        >
          <Button
            disabled={isReadOnly}
            color={deleteType === DELETE_TYPE.TOTAL ? "green" : "white"}
            onClick={() => this.changeType(DELETE_TYPE.TOTAL)}
          >
            <span>Total</span>
          </Button>
          <Button
            disabled={isReadOnly}
            color={deleteType === DELETE_TYPE.PARTIAL ? "green" : "white"}
            onClick={() => this.changeType(DELETE_TYPE.PARTIAL)}
          >
            <span>Parcial</span>
          </Button>
        </div>

        {deleteType === DELETE_TYPE.PARTIAL && !isReadOnly && (
          <p className="tip-text">
            Deja solo los productos y cantidad que deseas mantener en la factura
          </p>
        )}

        <table border={1} style={{width: "98%"}}>
          <thead>
            <tr>
              <td>Código</td>
              <td>Descripción</td>
              <td>Cantidad</td>
              <td>Precio</td>
              <td>Desc %</td>
              <td>Neto</td>
            </tr>
          </thead>
          <tbody>
            {returnedItem?.details?.map((item, index) => (
              <tr key={index} className={item.isDeleted ? "item-deleted" : ""}>
                <td>{item.product?.code}</td>
                <td>{item.product?.name}</td>
                <td className="quantity">
                  <Button
                    small
                    onClick={() => this.oneLessProduct(index)}
                    disabled={item.isDeleted || isReadOnly}
                  >
                    <i className="fa fa-minus" />
                  </Button>
                  <input
                    value={item.originalQuantity}
                    onChange={(e) => {
                      if (
                        item.product.decimal_stock ===
                        Constants.DECIMAL_STOCK.NO
                      ) {
                        if (
                          Globals.validateInteger(e.target.value) ||
                          e.target.value === ""
                        ) {
                          if (Number(e.target.value) > item.product.stock)
                            return;
                          this.changeManual(index, e.target.value);
                        }
                      } else {
                        if (Number(e.target.value) > item.product.stock) return;
                        this.changeManual(index, e.target.value);
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value === "") this.changeManual(index, "0");
                    }}
                    disabled={item.isDeleted || isReadOnly}
                  />
                  <Button
                    small
                    onClick={() => this.oneMoreProduct(index)}
                    disabled={item.isDeleted || isReadOnly}
                  >
                    <i className="fa fa-plus" />
                  </Button>
                </td>
                <td>Bs. {Globals.formatMiles(this.convert(item.price))}</td>
                <td>{item.discount_percentage}</td>
                <td align="right">
                  <span>
                    Bs.{" "}
                    {Globals.formatMiles(
                      this.convert(item.subtotalWithoutTaxes),
                    )}
                  </span>
                  {!isReadOnly && deleteType === DELETE_TYPE.PARTIAL && (
                    <>
                      {item.isDeleted ? (
                        <img
                          src={RecicleIcon}
                          className="btn-remove"
                          title="Mantener producto"
                          alt="Mantener producto"
                          onClick={() => this.toggleProduct(index)}
                        />
                      ) : (
                        <img
                          src={CloseIcon}
                          className="btn-remove"
                          title="Remover producto"
                          alt="Remover producto"
                          onClick={() => this.toggleProduct(index)}
                        />
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="modal-bottom">
          <div className="form">
            <div className="bill-number">
              <label>Número de Factura</label>
              <input value={form.bill_number} disabled />
            </div>
            <label>Motivo de nota de crédito</label>
            <textarea
              className="reason"
              value={form.comments}
              onChange={(v) => this.change(v.target.value, "comments")}
              disabled={isReadOnly}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "15px",
              }}
            >
              <input
                type="checkbox"
                id="affects_inventory_return"
                checked={!!form.affects_inventory}
                onChange={(e) =>
                  this.change(e.target.checked, "affects_inventory")
                }
                disabled={isReadOnly}
                style={{
                  cursor: isReadOnly ? "default" : "pointer",
                  width: "16px",
                  height: "16px",
                }}
              />
              <label
                htmlFor="affects_inventory_return"
                style={{
                  margin: 0,
                  cursor: isReadOnly ? "default" : "pointer",
                  fontWeight: "bold",
                }}
              >
                ¿Modifica inventario físico (Devolución)?
              </label>
            </div>
            <label>Método de pago</label>
            <Select
              className="filter"
              value={form.payment_method_id}
              options={this.state.methods.map((m) => ({
                value: m.id,
                label: m.name,
              }))}
              onChange={(e) => this.change(e.target.value, "payment_method_id")}
              disabled={isReadOnly ? true : false}
            />
          </div>

          <div className="totals">
            <div>
              <span>Sub-total</span>
              <span>Bs. {Globals.formatMiles(totals?.subtotal_bs || 0)}</span>
            </div>
            <div>
              <span>% Desc</span>
              <span>
                <span>
                  ({Globals.formatMiles(returnedItem?.discount_percentage)}
                  %){" "}
                </span>
                <span>
                  -Bs. {Globals.formatMiles(totals?.discount_bs || 0)}
                </span>
              </span>
            </div>
            <div>
              <span>IVA</span>
              <span>Bs. {Globals.formatMiles(totals?.iva_bs || 0)}</span>
            </div>
            {totals?.igtf_bs > 0 && (
              <div>
                <span>IGTF</span>
                <span>Bs. {Globals.formatMiles(totals?.igtf_bs || 0)}</span>
              </div>
            )}
            <div>
              <span>Total</span>
              <span>Bs. {Globals.formatMiles(totals?.total_bs || 0)}</span>
            </div>
          </div>
        </div>

        {!isReadOnly && (
          <div className="modal-actions">
            <button onClick={() => this.props.onClose()}>Cancelar</button>
            <button onClick={this.submit}>Procesar</button>
          </div>
        )}
      </>
    );
  }
}

export default connect((state) => ({
  user: state.user,
}))(ModalCreateReturn);
